const serviceData = [
  {
    title: "Figma to",
    title2: "Code",
    description:
      "Transforming pixel-perfect Figma designs into clean, responsive, and production-ready code using modern frontend stacks like React and Tailwind CSS.",
  },
  {
    title: "Custom",
    title2: "Web Dev..",
    description:
      "Building fully responsive and high-performance websites from scratch — combining sleek UI with scalable backend logic when needed.",
  },
  {
    title: "API",
    title2: "Integration",
    description:
      "Seamlessly connecting frontend interfaces with RESTful or GraphQL APIs, handling data fetching, error states, and dynamic rendering with efficiency.",
  },
  {
    title: "Component",
    title2: "Architecture",
    description:
      "Engineering reusable, scalable components and design systems to ensure maintainable codebases — ideal for growing products and teams.",
  },
  {
    title: "Full-stack",
    title2: "Solutions",
    description:
      "From database modeling to frontend polish, I deliver end-to-end solutions using technologies like Node.js, Express, and MongoDB — tailored to your business needs.",
  },
];

const servicesDataDetailed = [
  {
    title1: "Figma to",
    title2: "Code",
    tagline: "Pixel-perfect frontend from design files",
    shortDescription:
      "Translating Figma designs into responsive, production-ready code.",
    longDescription:
      "I specialize in converting UI/UX designs into clean, pixel-perfect, and fully responsive frontend code using React, HTML, CSS, and Tailwind CSS. From layout precision to smooth interactions, I ensure every detail of your design is faithfully implemented and optimized for performance.",
  },
  {
    title1: "Custom",
    title2: "Web Development",
    tagline: "Responsive websites, built from scratch",
    shortDescription:
      "Frontend and backend development tailored to your business goals.",
    longDescription:
      "I build custom websites and applications from the ground up using modern tech stacks like React, Next.js, Node.js, and MongoDB. Every solution is designed for performance, scalability, and long-term growth — with clean code and UX-focused interfaces at the core.",
  },
  {
    title1: "API",
    title2: "Integration",
    tagline: "Seamless backend connectivity",
    shortDescription: "Connecting user interfaces to powerful data sources.",
    longDescription:
      "I integrate RESTful and GraphQL APIs to power dynamic web applications. Whether fetching data from a CMS, third-party service, or custom backend, I handle state management, error handling, and UI feedback for smooth user experiences.",
  },
  {
    title1: "Component",
    title2: "Architecture",
    tagline: "Reusable and scalable codebases",
    shortDescription:
      "Modular UI components that speed up development and maintainability.",
    longDescription:
      "I develop atomic and reusable components using frameworks like React. This approach ensures scalability, consistency, and a clean development workflow — ideal for growing teams and products that demand design system adherence.",
  },
  {
    title1: "Full-stack",
    title2: "Solutions",
    tagline: "End-to-end web app development",
    shortDescription:
      "From database to deployment, I build complete web applications.",
    longDescription:
      "Whether it’s an MVP or a complex SaaS platform, I deliver complete full-stack solutions using technologies like Next.js, Express.js, and MongoDB. I take care of everything from database design to frontend UX and secure deployments.",
  },
  {
    title1: "Performance",
    title2: "Optimization",
    tagline: "Speed matters",
    shortDescription:
      "Boosting load speed, Core Web Vitals, and frontend responsiveness.",
    longDescription:
      "I audit and optimize your website’s performance — reducing bundle size, eliminating render-blocking resources, lazy loading assets, and improving Lighthouse/Core Web Vitals scores to ensure smooth, SEO-friendly web experiences.",
  },
  {
    title1: "CMS",
    title2: "Integration",
    tagline: "Dynamic content made easy",
    shortDescription: "Connecting your frontend to headless CMS platforms.",
    longDescription:
      "I integrate frontend apps with popular CMS platforms like Sanity, Contentful, and Strapi — giving you or your clients full control over content without compromising on design or speed. Perfect for blogs, marketing sites, and scalable content workflows.",
  },
  {
    title1: "Ongoing",
    title2: "Support & Maintenance",
    tagline: "Beyond launch",
    shortDescription: "Ensuring your website stays updated, secure, and fast.",
    longDescription:
      "After launch, I offer continued support — updating dependencies, fixing bugs, handling backups, monitoring uptime, and applying performance improvements. Ideal for businesses that want a reliable technical partner for long-term success.",
  },
];

export {serviceData, servicesDataDetailed};
